import axios from 'axios'

export default function FileSender(condition, callback) {


    axios.get(condition.url, {
        responseType : condition.responseType || 'blob'
    })

    .then(res => {

        callback({
            data : res.data,
            message : 'SUCCESS'           
        })

    })
    
    .catch(err => {

        callback({
            data : null,
            message : 'ERROR'
        })
    })

}




// WEBPACK FOOTER //
// ./src/controller/FileSender.js